/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as he from "he";
import React, { useState } from "react";
import { FormattedNumber } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import menuService from "../../services/menuService";
import {
  addItemToOrder,
  defaultMenuItemOption,
} from "../../state/actions/orderActions";
import { Menu, MenuItem } from "../../state/types/menuTypes";
import { RootState } from "../../state/store/store";
import Asset from "../Asset/Asset";
import MenuItemModal from "../Modal/MenuItemModal";

export interface IRecommendedItemsProps {
  items: ReadonlyArray<MenuItem>;
  menu: Menu;
  vendorId: number;
}

const RecommendedItems: React.FC<IRecommendedItemsProps> = ({
  items,
  menu,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  vendorId,
}) => {
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState<MenuItem | null>(null);
  const [showModal, setShowModal] = useState(false);

  const order = useSelector((state: RootState) => state.order);

  if (!items || items.length === 0) {
    return null;
  }

  const handleItemClick = (item: MenuItem) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleAddWithOptions = (item: MenuItem, selectedOptions: any[]) => {
    // Use "default" key when no modifiers are selected to match PlaceOrder page behavior
    const option =
      selectedOptions.length > 0 ? selectedOptions : defaultMenuItemOption;
    dispatch(
      // @ts-ignore - The reducer handles both string and array types for selectedOption
      addItemToOrder(item, option, item.promoted ? "PROMOTED" : "RECOMMENDED")
    );
    handleModalClose();
  };

  const getItemCountInOrder = (item: MenuItem): number => {
    return menuService.countMenuItem(order.userOrder, item);
  };

  return (
    <div className="RecommendedItems">
      <div className="recommendation-reason">Popular Additions</div>
      <div className="recommended-items-list">
        {items.map((item) => {
          const itemCount = getItemCountInOrder(item);
          return (
            <div
              key={item.id}
              className={`recommended-item ${
                itemCount > 0 ? "in-cart" : ""
              } clickable`}
              onClick={() => handleItemClick(item)}
            >
              <div className="recommended-item-content">
                {item.displayAssetId && (
                  <div className="recommended-item-image">
                    <Asset
                      thumbnailAssetId={item.displayAssetId}
                      transform={"100x"}
                    />
                  </div>
                )}
                <div className="recommended-item-info">
                  <div className="recommended-item-name">{item.name}</div>
                  {item.description && (
                    <div className="recommended-item-description">
                      {he.decode(item.description)}
                    </div>
                  )}
                  <div className="recommended-item-price">
                    {item.price.currencySymbol}
                    <FormattedNumber
                      minimumFractionDigits={2}
                      value={item.price.amount}
                    />
                  </div>
                </div>
              </div>
              <div className="recommended-item-action">
                {itemCount > 0 ? (
                  <span className="item-count-label">
                    In cart ({itemCount})
                  </span>
                ) : (
                  <span className="add-label">Tap to add</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {showModal && selectedItem && (
        <MenuItemModal
          isOpen={showModal}
          menuItem={selectedItem}
          menu={menu}
          onClose={handleModalClose}
          onAddToOrder={handleAddWithOptions}
        />
      )}
    </div>
  );
};

export default RecommendedItems;
